// src/pages/legal/CommunityStandardsPage.tsx
import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

const CommunityStandardsPage: React.FC = () => (
  <LegalDocumentPage slug="community-standards" fallbackTitle="Community Standards & Trust & Safety Policy" />
);

export default CommunityStandardsPage;
